module.exports = __webpack_public_path__ + "static/media/lavar-logo.f599255c.png";